module.exports = __webpack_public_path__ + "d41ae58dab60e355ae3872ebf2f1403a.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.ttf
// module id = 230
// module chunks = 0